import { Component, Input } from '@angular/core';

/**
 * Platzhalter-Karten während des Ladens. Vorher erschien nur ein kleiner Spinner
 * und die Liste sprang danach ins Bild - die Wartezeit wirkte dadurch länger,
 * als sie ist. Reines Anzeigeelement ohne Logik.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'list-skeleton',
  templateUrl: './list-skeleton.component.html',
  styleUrls: ['./list-skeleton.component.css'],
})
export class ListSkeletonComponent {
  /** Anzahl der Platzhalter-Karten. */
  @Input() count = 6;

  get placeholders(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }
}
